import axios from "axios";

import { IUserInfo, ICreatUserModel } from "./UserManagementModels";
import { UserAccessType } from "../user/Models";
import APP_CONFIG from "../app/configuration/AppConfig";

const BASE_URL = `${APP_CONFIG.serviceUrls.apiHostUrl}/users`;

export async function getUsers(): Promise<IUserInfo[]> {
  const url = BASE_URL;
  const response = await axios.get<IUserInfo[]>(url);
  return response.data;
}

export async function getUser(userId: string): Promise<IUserInfo> {
  const url = `${BASE_URL}/${userId}`;
  const response = await axios.get<IUserInfo>(url);
  return response.data;
}

export async function createUser(user: ICreatUserModel): Promise<string> {
  const url = BASE_URL;
  const response = await axios.post<string>(url, user);
  return response.data;
}

export async function updateUserRole(userId: string, role: UserAccessType): Promise<void> {
  const url = `${BASE_URL}/${userId}/role`;
  await axios.post(url, role, {
    headers: { "Content-Type": "application/json" },
  });
}

export async function updateUserSites(userId: string, sites: string[]): Promise<void> {
  const url = `${BASE_URL}/${userId}/sites`;
  await axios.post(url, sites, {
    headers: { "Content-Type": "application/json" },
  });
}

export async function updateUserStatus(userId: string, enabled: boolean): Promise<void> {
  const url = `${BASE_URL}/${userId}/${enabled ? "enable" : "disable"}`;
  await axios.post(url, undefined);
}
